'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createSvg = require('./utils/createSvg');

var _createSvg2 = _interopRequireDefault(_createSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createSvg2.default)(_react2.default.createElement(
  'g',
  null,
  _react2.default.createElement('path', { d: 'M6 6h2v12H6zm3.5 6l8.5 6V6z' })
), 'SkipPrevious');


//////////////////
// WEBPACK FOOTER
// ./~/material-react-icons/SkipPrevious.js
// module id = 850
// module chunks = 0